import React, { useEffect, useState } from 'react';

const SettingsCheckbox = ({ id, label, initialValue, defaultValue = false, onChange }) => {
  const [checked, setChecked] = useState(defaultValue);

  const handleChange = () => {
    setChecked(prev => {
      onChange(id, !prev);
      return !prev;
    });
  };

  useEffect(() => {
    setChecked(initialValue ?? defaultValue);
  }, [initialValue]);

  return (
      <div className="switcher-container align-items-center mb-4">
          <label className="ml-0 switcher mr-3">
              <input
                  type="checkbox"
                  id={label}
                  name={label}
                  checked={checked}
                  onChange={(e) => handleChange(e.target.checked)}
              />
              <span className="switcher-slider" />
          </label>

          <label htmlFor={label} className="switcher-label">
              <div className="paylixecommerce-label mb-0 cursor-pointer">{label}</div>
          </label>
      </div>
  );
};

export default SettingsCheckbox;
